import { render, staticRenderFns } from "./Beneficiario.vue?vue&type=template&id=1ae1fa68&scoped=true"
import script from "./Beneficiario.vue?vue&type=script&lang=js"
export * from "./Beneficiario.vue?vue&type=script&lang=js"
import style0 from "./Beneficiario.vue?vue&type=style&index=0&id=1ae1fa68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae1fa68",
  null
  
)

export default component.exports